import React, { useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Play, Plus, ThumbsUp } from "lucide-react";
import { Link } from "react-router-dom";

const MovieSlider = ({ movies }) => {
  const [activeMovie, setActiveMovie] = useState(movies[0]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    fade: true,
    beforeChange: (_, newIndex) => {
      setActiveMovie(movies[newIndex]);
    },
  };

  const fallbackBackground = "/images/background1.png";

  const backgroundImage = activeMovie.backdrop_path
    ? `url(https://image.tmdb.org/t/p/original${activeMovie.backdrop_path})`
    : activeMovie.banner
      ? `url(${activeMovie.banner.replace(/\s+/g, "%20")})`
      : `url(${fallbackBackground})`;

  return (
    <div className="relative w-full overflow-hidden min-h-[90vh]">
      {/* Background Image with Subtle Overlay */}
      <div
        key={activeMovie.id}
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent"></div>
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Slider Content */}
      <div className="relative z-10 container mx-auto px-4 h-full flex items-center pt-20 pb-10">
        <Slider {...settings} className="w-full">
          {movies.map((movie) => (
            <div
              key={movie.id}
              className="flex flex-col lg:flex-row items-center gap-8 py-10"
            >
              {/* Movie Poster */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative group"
              >
                <img
                  src={
                    movie.poster_path
                      ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
                      : movie.poster
                  }
                  alt={movie.title}
                  className="w-[250px] md:w-[300px] lg:w-[350px] h-auto rounded-lg shadow-lg transition-all duration-300 group-hover:shadow-xl"
                />
              </motion.div>

              {/* Movie Info */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex flex-col gap-4 text-white max-w-lg"
              >
                <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-shadow">
                  {movie.title}
                </h1>

                <div className="flex flex-wrap items-center gap-3 text-sm md:text-base">
                  {movie.vote_average && (
                    <span className="font-semibold text-green-400">
                      {Math.round(movie.vote_average * 10)}% coincidencia
                    </span>
                  )}
                  {movie.release_date && (
                    <span>{movie.release_date.split("-")[0]}</span>
                  )}
                  <span className="px-2 py-0.5 border border-gray-300 rounded-md">16+</span>
                  {movie.runtime && <span>{movie.runtime} min</span>}
                  <span className="px-2 py-0.5 border border-gray-300/40 rounded-md text-xs">
                    HD
                  </span>
                </div>
                <p className="text-gray-200 leading-relaxed font-bold">
                  {movie.name}
                </p>
                <p className="text-gray-100 leading-relaxed">
                  {movie.overview || movie.description}
                </p>

                {/* Movie Actions - Aumenté el padding vertical aquí */}
                <div className="flex items-center gap-3 mt-6">
                  <Link to={`/movies/movie/${movie.id}`}>
                    <button className="flex items-center px-6 py-3 text-sm font-medium text-black bg-white rounded-md hover:bg-white/90 transition-colors">
                      <Play className="w-5 h-5 mr-2" fill="black" />
                      Reproducir
                    </button>
                  </Link>

                  {/* <button className="p-3 rounded-full bg-white/20 hover:bg-white/30 transition-colors">
                    <Plus className="w-5 h-5 text-white" />
                  </button>
                  
                  <button className="p-3 rounded-full bg-white/20 hover:bg-white/30 transition-colors">
                    <ThumbsUp className="w-5 h-5 text-white" />
                  </button> */}
                </div>
              </motion.div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default MovieSlider;